export enum UserReportType {
    ACTIVATED_ACCOUNT = 1,
    DEACTIVATED_ACCOUNT = 3,
    REPORT_ABUSE = 5
}
